// @ts-check
import { css, jsx } from '@emotion/core';
import React from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import useStaffProfiles from "./useStaffProfiles";

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};

const SubjectSort = () => {
  const { data, loading } = useStaffProfiles('subject');

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey={(record, i) => {
        return `${record.personId}-${i + 1}`;
      }}
      showHeader={false}
      pagination={false}
      scroll={{ x: 780 }}
      css={css`
        .ant-table-row-cell-break-word {
          white-space: normal !important;
        }
      `}
    />
  );
};

/** @type {import("./useStaffProfiles").StaffProfileColumn[]} */
const columns = [
  {
    title: 'Subject',
    dataIndex: 'subject',
    render: text => {
      return <p css={style.sorterText}>{text}</p>;
    },
    width: '350px',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text, record) => {
      return (
        <Link anchor css={style.name} href={`mailto:${record.emailAddress}`}>
          {text}
        </Link>
      );
    },
    width: '250px',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    render: text => {
      return (
        <Link anchor href={`tel:${text}`}>
          {text}
        </Link>
      );
    },
    width: '180px',
  },
];

export default SubjectSort;
